// extracted by mini-css-extract-plugin
export default {"memberNotice":"PricingMemberNotice_memberNotice__H2Xlr"};